import { render, staticRenderFns } from "./components.vue?vue&type=template&id=5152573e&scoped=true&"
import script from "./components.vue?vue&type=script&lang=js&"
export * from "./components.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5152573e",
  null
  
)

export default component.exports